<template>
  <div>
    <!-- 首页背景 -->
    <div class="login-admin-title">
      <div class="login-admin-text">登录</div>
    </div>
    <!-- 学校内容 -->
    <div class="login-school-admin">
      <div class="login-school-admin-content">
        <div class="login-school-show">
          <div class="login-school-img-box">
            <img src="../../assets/images/login-sinlg.png" alt="">
          </div>
          <div class="login-school-name">{{ schoolName ? schoolName : '' }}</div>
        </div>
        <!-- 身份选择 -->
        <div class="identity-select">
          <div :class="isShowTeacher ? 'identity-box1' : 'identity-box'" @click="TeacherLogin">
            <div
              :class="isShowTeacher ? 'identity-icon-box identity-icon-box-select' : 'identity-icon-box identity-icon-box1'">
              <div
                :class="isShowTeacher ? 'identity-teacher-icon identity-teacher-icon-select' : 'identity-teacher-icon identity-teacher-icon1'">
              </div>
            </div>
            <div class="identity-text">教师登录</div>
          </div>
          <div :class="isShowStudent ? 'identity-box1' : 'identity-box'" @click="StudentLogin">
            <div
              :class="isShowStudent ? 'identity-icon-box identity-icon-box-select' : 'identity-icon-box identity-icon-box1'">
              <div
                :class="isShowStudent ? 'identity-student-icon identity-student-icon-select' : 'identity-student-icon identity-student-icon1'">
              </div>
            </div>
            <div class="identity-text">学生登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolName: '',
      domain: window.location.host,
      isShowTeacher: false,
      isShowStudent: false,
    }
  },
  mounted() {
    console.log(window.location.host, 'dddd');
    this.getSchoolName();
  },
  methods: {
    TeacherLogin() {
      if (this.schoolName != '') {
        this.isShowTeacher = true;
        this.isShowStudent = false;
        this.$router.replace({ name: 'LoginTeacher', query: { schoolName: this.schoolName, schoolId: this.schoolId } });
      } else {
        this.$message.warnging('学校信息获取中，请耐心等待或者刷新页面~');
      }
    },
    StudentLogin() {
      if (this.schoolName != '') {
        this.isShowTeacher = false;
        this.isShowStudent = true;
        this.$router.replace({ name: 'LoginStudent', query: { schoolName: this.schoolName, schoolId: this.schoolId } });
      } else {
        this.$message.warnging('学校信息获取中，请耐心等待或者刷新页面~');
      }
    },
    getSchoolName() {
      this.$http.get('/api/admin/school/getDomainSchool', { params: { domain: this.domain } }).then(res => {
        this.schoolName = res.data.schoolName
        this.schoolId = res.data.schoolId
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/user/login.vue